<div id="change-reservation-amounts" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body" *ngIf="available === false && loading === false">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="bold color-grey uk-text-uppercase">Changer les montants de la réservation</h2>
                <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-top uk-margin-small-bottom">
                    Indisponible pour le moment, veuillez réessayer ultérieurement.
                </label>
            </div>
        </div>
        <div class="uk-modal-body waiting" *ngIf="loading === true">
            <div uk-spinner class="uk-position-center"></div>
        </div>
        <div class="uk-modal-body" *ngIf="available === true && loading === false">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove" *ngIf="loading === false">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Changer les montants de la réservation
                </h2>
                <div class="uk-margin" *ngFor="let field of invoiceFields; let i = index;">
                    <div class="uk-form-controls uk-margin-small-top">
                        <div uk-grid class="remove-grid-ml-pl">
                            <div class="uk-width-expand">
                                <input class="input alt color-cold-grey bold uk-width-1-1" min="0" type="text" [(ngModel)]="field.Title" style="padding: 4px">
                            </div>
                            <div class="uk-width-5-12 uk-position-relative">
                                <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" min="0" [(ngModel)]="field.Quantity" type="number" style="padding: 4px; width: 50px;">
                                <span class="vertical-align uk-margin-left">x</span>
                                <div class="uk-form-controls uk-position-relative uk-display-inline-block">
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" min="0" [(ngModel)]="field.IncludingTaxes" type="number" style="padding: 4px; width: 90px;">
                                    <span class="uk-form-icon uk-form-icon-flip small-font">€ TTC</span>
                                </div>
                            </div>
                            <div class="uk-width-1-12 uk-position-relative">
                                <button class="uk-button uk-button-link color-dark-gray uk-margin-small-right" type="button">
                                    <span class="material-icons">more_horiz</span>
                                </button>
                                <div uk-dropdown="pos: right-center">
                                    <ul class="uk-nav uk-dropdown-nav">
                                        <li><a (click)="deleteField(field)" href="javascript:void(0)">Supprimer</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div uk-grid class="remove-grid-ml-pl uk-grid-small uk-margin-bottom" *ngFor="let field of invoiceFields; let i = index;">
                    <div class="uk-width-12-12">
                        <div class="uk-display-inline-block">
                            <label class="uk-form-label uk-display-inline-block vop-blue bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                                {{ i + 1 }}
                            </label>
                            <div class="uk-form-controls uk-display-inline-block">
                                <input class="input" style="width: 250px;" type="text" [(ngModel)]="field.Title">
                            </div>
                        </div>
                        <div class="uk-float-right">
                            <button class="uk-button uk-button-link color-dark-gray uk-margin-small-right" type="button">
                                <span class="material-icons">more_horiz</span>
                            </button>
                            <div uk-dropdown="pos: right-center">
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li><a (click)="deleteField(field)" href="javascript:void(0)">Supprimer</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-6-12">
                        <div class="uk-display-inline-block">
                            <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                                HT
                            </label>
                            <div class="uk-form-controls uk-display-inline-block">
                                <input class="input" type="number" [(ngModel)]="field.ExcludingTaxes">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-6-12">
                        <div class="uk-display-inline-block">
                            <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                                TTC
                            </label>
                            <div class="uk-form-controls uk-display-inline-block">
                                <input class="input" type="number" [(ngModel)]="field.IncludingTaxes">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-6-12">
                        <div class="uk-display-inline-block">
                            <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                                Qt
                            </label>
                            <div class="uk-form-controls uk-display-inline-block">
                                <input class="input" type="number" [(ngModel)]="field.Quantity">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-6-12 uk-margin-bottom">
                        <div class="uk-display-inline-block">
                            <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                                VAT
                            </label>
                            <div class="uk-form-controls uk-display-inline-block">
                                <input class="input" type="number" [(ngModel)]="field.VAT">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-12-12 separator-horizontal"></div>
                </div>-->
            </div>
            <div uk-grid class="remove-grid-ml-pl uk-grid-small add-field">
                <div class="uk-width-12-12">
                    <div class="uk-display-inline-block">
                        <label class="uk-form-label uk-display-inline-block vop-blue bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                            Nouveau
                        </label>
                        <div class="uk-form-controls uk-display-inline-block">
                            <input class="input alt bold color-cold-grey" style="width: 250px;" type="text" [(ngModel)]="newField.Title">
                        </div>
                    </div>
                </div>
                <div class="uk-width-6-12">
                    <div class="uk-display-inline-block">
                        <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                            Montant TTC
                        </label>
                        <div class="uk-form-controls uk-position-relative uk-display-inline-block">
                            <span class="uk-form-icon uk-form-icon-flip small-font">€ TTC</span>
                            <input class="input alt bold color-cold-grey" min="0" type="number" [(ngModel)]="newField.IncludingTaxes">
                        </div>
                    </div>
                </div>
                <div class="uk-width-6-12">
                    <div class="uk-display-inline-block">
                        <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                            Quantité
                        </label>
                        <div class="uk-form-controls uk-display-inline-block">
                            <input class="input alt bold color-cold-grey" min="0" type="number" [(ngModel)]="newField.Quantity">
                        </div>
                    </div>
                </div>
                <div class="uk-width-12-12">
                    <p class="uk-text-right">
                        <button class="button bold" (click)="addField()">Ajouter</button>
                    </p>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" (click)="reloadInvoiceFields()" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" (click)="updateInvoice()">Sauvegarder</button>
            </p>
        </div>
    </div>
</div>